"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var owa_mail_list_store_1 = require("owa-mail-list-store");
function setRowsFlagStateHelper(itemRowKeys, tableViewId, flagStatusToApply, setRowsFlagStateInternal) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    // Filter out the rows which has the same flag type as the new flag type
    var filteredRowKeys = itemRowKeys.filter(function (rowKey) { return owa_mail_list_store_1.MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView) != flagStatusToApply; });
    if (filteredRowKeys.length == 0) {
        // Nothing to set flag status on
        return;
    }
    setRowsFlagStateInternal(filteredRowKeys, flagStatusToApply);
}
exports.default = setRowsFlagStateHelper;
//# sourceMappingURL=setRowsFlagStateHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/setRowsFlagStateHelper.js
// module id = 3818
// module chunks = 62